module.exports = __webpack_public_path__ + "img/peijian_active.55240d7b.png";